package org.gymly.auth

enum class StoredAuthKind {
    ADMIN,
    CLIENT,
}

/** Persiste tokens JWT en web (localStorage). No-op en otras plataformas. */
expect object AuthPersistence {
    fun save(kind: StoredAuthKind, token: String)
    fun load(kind: StoredAuthKind): String?
    fun clear(kind: StoredAuthKind)
    fun clearAll()
    fun saveLastKind(kind: StoredAuthKind)
    fun loadLastKind(): StoredAuthKind?
    fun saveLastActivityAt(epochMs: Long)
    fun loadLastActivityAt(): Long?
    fun clearLastActivityAt()
}
